import React, {
  useState,
  useEffect,
  useReducer,
  useContext,
  useRef,
} from "react";

import Card from "../UI/Card/Card";
import classes from "./Login.module.css";
import Button from "../UI/Button/Button";
import AuthContext from "../../store/auth-context";
import Input from "../UI/Input/Input";
import { GoogleLogin } from "@react-oauth/google";

const emailReducer = (state, action) => {
  if (action.type === "USER_INPUT") {
    //action.value ist der Payload
    return { value: action.value, isValid: action.value.includes("@") };
  }
  if (action.type === "INPUT_BLUR") {
    return { value: state.value, isValid: state.value.includes("@") }; // prüfung auf @ in funktion auslagern
  }
  return { value: "", isValid: false };
};

// last state, and the action that was dispatched
const passwordReducer = (state, action) => {
  if (action.type === "USER_INPUT") {
    return { value: action.value, isValid: action.value.trim().length > 6 };
  }
  if (action.type === "INPUT_BLUR") {
    return { value: state.value, isValid: state.value.trim().length > 6 };
  }
  return { value: "", isValid: false };
};

const Login = (props) => {
  // DEBOUNCING -> AUSKOMMENTIERTES ZEUGS
  // const [enteredEmail, setEnteredEmail] = useState("");
  // const [emailIsValid, setEmailIsValid] = useState();
  // const [enteredPassword, setEnteredPassword] = useState("");
  // const [passwordIsValid, setPasswordIsValid] = useState();
  const [formIsValid, setFormIsValid] = useState(false);

  const [emailState, dispatchEmail] = useReducer(emailReducer, {
    value: "",
    isValid: null,
  });
  // useReducer(passwordReducer, value...) -> second argument is the initial state
  const [passwordState, dispatchPassword] = useReducer(passwordReducer, {
    value: "",
    isValid: null,
  });

  const authCtx = useContext(AuthContext);

  const emailInputRef = useRef();
  const passwordInputRef = useRef();

  // runs after every component rendering cycle
  useEffect(() => {
    console.log("EFFECT RUNNING");

    // this cleanup function runs before this state function  as whole runs,
    // but not before the first time it runs (but only if a dependency is set)
    return () => {
      console.log("EFFECT CLEANUP");
    };
  }, []); // ohne dependecies läuft 'return () => {}' erst wenn die komponente vom DOM entfernt wurde

  // alias assignment with object destructuring
  const { isValid: emailIsValid } = emailState;
  const { isValid: passwordIsValid } = passwordState;

  // wird ausgeführt wenn sich die Werte der Dependencies ändern
  // debouncing
  useEffect(() => {
    const identifier = setTimeout(() => {
      console.log("Check form validity!");
      setFormIsValid(emailIsValid && passwordIsValid);
    }, 500);

    // debouncing
    // cleanup function
    return () => {
      console.log("CLEANUP");
      clearTimeout(identifier);
    };
  }, [emailIsValid, passwordIsValid]);

  const emailChangeHandler = (event) => {
    //setEnteredEmail(event.target.value);
    // params -> Object -> {action, payload} --> wird als Action übergeben
    dispatchEmail({ type: "USER_INPUT", value: event.target.value });

    // ohne useEffect
    // setFormIsValid(event.target.value.includes("@") && passwordState.isValid);
  };

  const passwordChangeHandler = (event) => {
    //setEnteredPassword(event.target.value);
    dispatchPassword({ type: "USER_INPUT", value: event.target.value });

    // ohne useEffect
    // setFormIsValid(emailState.isValid && event.target.value.trim().length > 6);
  };

  const validateEmailHandler = () => {
    // setEmailIsValid(emailState.isValid);
    // INPUT_BLUR: Input lost focus
    dispatchEmail({ type: "INPUT_BLUR" });
  };

  const validatePasswordHandler = () => {
    //setPasswordIsValid(enteredPassword.trim().length > 6);
    dispatchPassword({ type: "INPUT_BLUR" });
  };

  const submitHandler = (event) => {
    event.preventDefault();
    if (formIsValid) {
      authCtx.onLogin(emailState.value, passwordState.value);
    } else if (!emailIsValid) {
      emailInputRef.current.focus();
    } else {
      passwordInputRef.current.focus();
    }
  };

  return (
    <>
      {authCtx.loginError && <h2 style={{ textAlign: "center", color: "#ffffffff" }}>{authCtx.loginError}</h2>}
      <Card className={classes.login}>
        <form onSubmit={submitHandler}>
          <Input
            ref={emailInputRef}
            id="email"
            label="E-Mail"
            type="email"
            isValid={emailIsValid}
            value={emailState.value}
            onChange={emailChangeHandler}
            onBlur={validateEmailHandler}
          />
          <Input
            ref={passwordInputRef}
            id="password"
            label="Password"
            type="password"
            isValid={passwordIsValid}
            value={passwordState.value}
            onChange={passwordChangeHandler}
            onBlur={validatePasswordHandler}
          />
          <div className={classes.actions}>
            <Button type="submit" className={classes.btn}>
              Login
            </Button>
          </div>
          <div className={classes.actions} style={{ marginTop: '1rem', display: 'flex', justifyContent: 'center' }}>
            <GoogleLogin
              onSuccess={(credentialResponse) => {
                console.log("Google Login Success", credentialResponse);
                authCtx.onGoogleLogin(credentialResponse.credential);
              }}
              onError={() => {
                console.log('Google Login Failed');
              }}
            />
          </div>
        </form>
      </Card>
    </>
  );
};

export default Login;
